import PropTypes from 'prop-types';
import { CalendarTitle } from './calendar-title';
import { CalendarButton } from './calendar-button';

import styles from './CalendarHeader.scss';

export const CalendarHeader = ({ month, year, onPrevious = null, onNext = null }) => (
  <div className={styles.Calendar__header}>
    <CalendarButton
      isVisible={!onPrevious}
      onClick={onPrevious}
      buttonClassName="Calendar__prev"
      buttonText="Earlier dates"
    />
    <CalendarTitle month={month} year={year} />
    <CalendarButton
      isVisible={!onNext}
      onClick={onNext}
      buttonClassName="Calendar__next"
      buttonText="Later dates"
    />
  </div>
);

CalendarHeader.propTypes = {
  month: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
};
